import { SearchAction, SearchObject, TagAction } from './Models';
import { P2GAlert, P2GButton, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { useInfiniteHits } from 'react-instantsearch-core';

export interface IHitProps {
  hit: SearchObject;
  searchActions?: SearchAction;
  additionalTags?: TagAction;
}

export interface IHitsProps {
  hit?: SearchAction;
  hideFilter?: boolean;
}

const Hits: React.FC<IHitsProps> = (props) => {
  const hitsState = useInfiniteHits<SearchObject>();

  if (!hitsState.items || hitsState.items.length === 0) {
    return (
      <P2GAlert color="info">
        <P2GText>No Results...</P2GText>
      </P2GAlert>
    );
  }

  return (
    <P2GGrid container spacing={2} direction="column">
      {!props.hideFilter && hitsState.isFirstPage === false && (
        <P2GGrid item xs={12}>
          <P2GButton onClick={hitsState.showPrevious} fullWidth>
            Load Previous
          </P2GButton>
        </P2GGrid>
      )}
      <P2GGrid item xs={12}>
        <P2GGrid container spacing={2} direction="column">
          {hitsState.items.map((hit) => (
            <P2GGrid item key={hit.orderLineId}>
              {props.hit ? props.hit(hit) : null}
            </P2GGrid>
          ))}
        </P2GGrid>
      </P2GGrid>
      {!props.hideFilter && hitsState.isLastPage === false && (
        <P2GGrid item xs={12}>
          <P2GButton onClick={hitsState.showMore} fullWidth>
            Load More
          </P2GButton>
        </P2GGrid>
      )}
    </P2GGrid>
  );
};

export default Hits;
